var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 104,
	"./layouts/card/style.module.scss": 104,
	"./layouts/components/breadcrumbs": 137,
	"./layouts/components/breadcrumbs/": 137,
	"./layouts/components/breadcrumbs/index": 137,
	"./layouts/components/breadcrumbs/index.tsx": 137,
	"./layouts/components/breadcrumbs/style.module": 197,
	"./layouts/components/breadcrumbs/style.module.scss": 197,
	"./layouts/components/container": 49,
	"./layouts/components/container/": 49,
	"./layouts/components/container/index": 49,
	"./layouts/components/container/index.tsx": 49,
	"./layouts/components/container/style.module": 139,
	"./layouts/components/container/style.module.scss": 139,
	"./layouts/components/footer": 138,
	"./layouts/components/footer/": 138,
	"./layouts/components/footer/index": 138,
	"./layouts/components/footer/index.tsx": 138,
	"./layouts/components/footer/style.module": 95,
	"./layouts/components/footer/style.module.scss": 95,
	"./layouts/components/loading_indicator": 55,
	"./layouts/components/loading_indicator/": 55,
	"./layouts/components/loading_indicator/index": 55,
	"./layouts/components/loading_indicator/index.tsx": 55,
	"./layouts/components/nav_bar": 103,
	"./layouts/components/nav_bar/": 103,
	"./layouts/components/nav_bar/index": 103,
	"./layouts/components/nav_bar/index.tsx": 103,
	"./layouts/components/nav_bar/standalone": 370,
	"./layouts/components/nav_bar/standalone.tsx": 370,
	"./layouts/components/nav_bar/style.module": 37,
	"./layouts/components/nav_bar/style.module.scss": 37,
	"./layouts/components/notice_banner": 94,
	"./layouts/components/notice_banner/": 94,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 198,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 198,
	"./layouts/components/notice_banner/index": 94,
	"./layouts/components/notice_banner/index.tsx": 94,
	"./layouts/components/notice_banner/standalone": 371,
	"./layouts/components/notice_banner/standalone.tsx": 371,
	"./layouts/components/notice_banner/style.module": 199,
	"./layouts/components/notice_banner/style.module.scss": 199,
	"./layouts/page": 106,
	"./layouts/page/": 106,
	"./layouts/page/index": 106,
	"./layouts/page/index.tsx": 106,
	"./layouts/page/style.module": 96,
	"./layouts/page/style.module.scss": 96,
	"./layouts/types": 372,
	"./layouts/types.ts": 372,
	"./marketing/pages/home/toefl": 1589,
	"./marketing/pages/home/toefl/": 1589,
	"./marketing/pages/home/toefl/index": 1589,
	"./marketing/pages/home/toefl/index.tsx": 1589,
	"./marketing/pages/home/toefl/sections/ai": 1179,
	"./marketing/pages/home/toefl/sections/ai/": 1179,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1809,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1809,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1810,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1810,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1811,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1811,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1812,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1812,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge": 1813,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge.svg": 1813,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1814,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1814,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1815,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1815,
	"./marketing/pages/home/toefl/sections/ai/index": 1179,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1179,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1816,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1816,
	"./marketing/pages/home/toefl/sections/apps": 1180,
	"./marketing/pages/home/toefl/sections/apps/": 1180,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1817,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1817,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1818,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1818,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1819,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1819,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1820,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1820,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1821,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1821,
	"./marketing/pages/home/toefl/sections/apps/index": 1180,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1180,
	"./marketing/pages/home/toefl/sections/features": 1181,
	"./marketing/pages/home/toefl/sections/features/": 1181,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1822,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1822,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1823,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1823,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1824,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1824,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1825,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1825,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1826,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1826,
	"./marketing/pages/home/toefl/sections/features/index": 1181,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1181,
	"./marketing/pages/home/toefl/sections/official_questions": 1185,
	"./marketing/pages/home/toefl/sections/official_questions/": 1185,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1835,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1835,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1185,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1185,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 711,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 711,
	"./marketing/pages/home/toefl/sections/value_props": 1182,
	"./marketing/pages/home/toefl/sections/value_props/": 1182,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1827,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1827,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1828,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1828,
	"./marketing/pages/home/toefl/sections/value_props/index": 1182,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1182,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2210,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2210,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1183,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1183,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1829,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1829,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1830,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1830,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1831,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1831,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1832,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1832,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1833,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1833,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1183,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1183,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 710,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 710,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1184,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1184,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1834,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1834,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1184,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1184,
	"./marketing/pages/home/toefl/style.module": 1836,
	"./marketing/pages/home/toefl/style.module.scss": 1836,
	"./marketing/pages/plans/toefl": 1590,
	"./marketing/pages/plans/toefl/": 1590,
	"./marketing/pages/plans/toefl/index": 1590,
	"./marketing/pages/plans/toefl/index.tsx": 1590,
	"./marketing/pages/plans/toefl/sections/testimonials": 1186,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1186,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1837,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1837,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1838,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1838,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1186,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2548;